const getInitialState = () => ({
  usedIds: [], // 当前使用的cai历史语料的Id列表
});
export default getInitialState();
